@if (loading$ | async) {
  <app-loading [size]="'3x'"></app-loading>
}

@if (!(loading$ | async)) {
  <div class="algorithms">
    @let attached = (attachedAlgorithms$ | async) ?? [];
    @let pending = (pendingAlgorithmIds$ | async) ?? [];

    @if (attached.length === 0) {
      <div class="no-algorithms">
        {{
          "feed-algorithms.message.no-algorithms-are-scheduled-on-this-feed"
            | translate
        }}
      </div>
    }

    @for (algorithm of attached; track algorithm.id) {
      <app-algorithm-list-card
        [algorithm]="algorithm"
        [pending]="isAlgorithmPending(algorithm.id, pending)"
        [editable]="hasEditableParams(algorithm)"
        (detach)="detachAlgorithm($event)"
        (edit)="editAlgorithm($event)"
      ></app-algorithm-list-card>
    }
  </div>
}
